const EMAIL = "hello@kingterrier.io";

export interface SocialLink {
    readonly label: string;
    readonly href: string;
}

export const site = {
    // The nav wordmark.
    name: "King Terrier Software",
    email: EMAIL,
    mailto: `mailto:${EMAIL}`,
    // The design specifies 2026 rather than the current year, so this stays a literal.
    // Full legal name here; the nav wordmark above is the trading name.
    copyright: "© 2026 King Terrier Software, LLC",
    socials: [
        { label: "GitHub", href: "https://github.com/wmluke" },
        { label: "LinkedIn", href: "https://www.linkedin.com/in/wmluke/" },
        { label: "Twitter", href: "https://x.com/wmluke" },
    ] as readonly SocialLink[],
    titles: {
        home: "King Terrier Software",
        about: "About — King Terrier Software",
    },
} as const;
